// Override with REACT_APP_API_BASE_URL in a .env file
// Restart `npm start` after changing it.

export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL ||
    "https://eapi.octaloptimum.in/api/v1/";
//"http://localhost:5900/api/v1/";

export const API_PATHS = {
    // Authentication
    adminlogin: "admin/login",
    userlogin: "user/login",

    // Dashboard
    admindashboard: "admin/dashboard",
    getadminprofile: "admin/me",

    // Booths
    getbooths: "admin/booths",
    addbooth: "admin/booths",
    getbooth: "admin/booths/:id",
    updatebooth: "admin/booths/:id",

    // Hierarchy
    getsubdivisions: "admin/subdivisions",
    getcircles: "admin/circles",
    getstations: "admin/stations",
    addstation: "admin/stations/create",

    // SOS Alerts
    getsosalerts: "admin/sos",
    resolvesos: "admin/sos/:id/resolve",
    cancelsos: "admin/sos/:id/cancel",

    // Officers
    getofficers: "admin/officers",
    createofficer: "admin/officers/create",
    bulkcreateofficer: "admin/officers/bulk-create",
    bulkcreatesubdivision: "admin/bulk-subdivisions",
    bulkcreatecircle: "admin/bulk-circles",
    bulkcreatestation: "admin/bulk-stations",
    bulkcreatebooth: "admin/bulk-booths",
    updateofficer: "admin/officers/:id",
    deleteofficer: "admin/officers/:id",
    syncofficerassignments: "admin/sync-officer-assignments",
};